import request from "../utils/request"

export const getDashboardStats = (params = {}) => {
	const queryString = new URLSearchParams(params).toString()
	return request.get(`/dashboard${queryString ? `?${queryString}` : ""}`)
}
